import React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { styled } from 'linaria/react'
import brandCategoryQuery from './brandCategoryQuery.gql'
import Brandlist from './Brandlist'
import RenderCustomElements from '../../CustomElements/RenderCustomElements'
import { BRAND_PAGE_ID } from '../../Core/Util/Constants'
import StandardCategoryBanner from '../../Core/Banners/StandardCategoryBanner'
import { VB_CATEGORY_SETTINGS } from '../../CustomElements/elementTypes'
import { useIntl } from '@jetshop/intl'

const BrandContainer = styled.div`
   background: #fff;
   .brandlist-title h3 {
      font-weight: 700;
      font-size: 2.875rem;
   }
`

const Brands = ({ category, parents }) => {
   const t = useIntl()
   // Static value, change to a proper check from passed props?
   const isSingleBrand = false

   const { data } = useQuery(brandCategoryQuery, {
      variables: { id: BRAND_PAGE_ID },
   })

   const brands = data?.category?.subcategories

   const groupedBrands = {}

   brands?.forEach(item => {
      const firstLetter = item.name.charAt(0).toUpperCase()
      if (!groupedBrands[firstLetter]) {
         groupedBrands[firstLetter] = []
      }
      groupedBrands[firstLetter].push(item)
   })

   const items = category?.data?.items
   const categorySettings = items?.find(c => c?.type == VB_CATEGORY_SETTINGS)

   return (
      <>
         <StandardCategoryBanner
            category={category}
            parents={parents}
            categorySettings={categorySettings}
            isSingleBrand={isSingleBrand}
         ></StandardCategoryBanner>
         <RenderCustomElements items={items} />
         <BrandContainer className="container-fluid p-0 m-0 brandslist-wrapper">
            <div className="brandlist-title px-128 py-32">
               <h3>{t('search among our brands')}</h3>
            </div>
            <Brandlist brands={groupedBrands}></Brandlist>
         </BrandContainer>
      </>
   )
}

export default Brands
